module.exports = __webpack_public_path__ + "img/pen.a3cfd800.svg";